import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import "../../components/styles/parentalPage.scss";

/**
 * ParentalPage — Parental controls / Kids accounts
 * Figma: 1.1 Parental (Desktop) (24654:5567) — 1920×1556
 *
 * Layout:
 *   - Navbar
 *   - "Parental" title
 *   - Tab bar: Settings | Subscription | Parental (active)
 *   - Card: "Kids account" heading
 *     - Profile rows: avatar + name + rating description + chevron
 *     - "Add new account" button
 *   - Download app + Footer
 */

const TABS = ["Settings", "Subscription", "Parental"];

const KIDS_ACCOUNTS = [
  { id: 1, name: "Selly", rating: "All maturity ratings", color: "#6d28d9" },
  { id: 2, name: "Selly", rating: "G & PG Ratings", color: "#22c55e" },
];

const TAB_ROUTES = {
  "Settings": "/settings",
  "Subscription": "/settings/subscription",
  "Parental": "/settings/parental",
};

const ParentalPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Parental");

  return (
    <div className="parental-page">
      <Navbar activeTab="" />

      <div className="parental-page__body">
        <h1 className="parental-page__title">Parental</h1>

        {/* Tab bar */}
        <div className="parental-page__tabs">
          {TABS.map((tab) => (
            <button
              key={tab}
              className={`parental-page__tab ${
                activeTab === tab ? "parental-page__tab--active" : ""
              }`}
              onClick={() => {
                setActiveTab(tab);
                navigate(TAB_ROUTES[tab]);
              }}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Kids account card */}
        <div className="parental-page__card">
          <h3 className="parental-page__card-title">Kids account</h3>

          {KIDS_ACCOUNTS.map((account) => (
            <button key={account.id} className="parental-page__account-row" onClick={() => navigate(`/settings/parental/${account.name.toLowerCase()}`)}>
              <div
                className="parental-page__account-avatar"
                style={{ backgroundColor: account.color }}
              >
                <span className="parental-page__account-initial">
                  {account.name.charAt(0)}
                </span>
              </div>
              <div className="parental-page__account-info">
                <span className="parental-page__account-name">{account.name}</span>
                <span className="parental-page__account-rating">{account.rating}</span>
              </div>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.5 5L12.5 10L7.5 15" stroke="#737373" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          ))}

          <button className="parental-page__add-btn">Add new account</button>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ParentalPage;
